<!-- FIXME: if-->
<ng-container *ngIf="tenant == 13">
  <qm-influx-graph
    bucket="miso-measurements"
    measurement="miso"
    [filterFields]="['valvomo', 'tunnus', 'symboli', '_field']"
    [filterDefaults]="{'_field': 'avg'}"
  ></qm-influx-graph>
</ng-container>
<ng-container *ngIf="tenant === 14">
  <qm-neve-measurements></qm-neve-measurements>
</ng-container>
